export enum PAGE_STATUS {
  LOGIN = 'login',
  CHECK_EMAIL = 'check_email',
  RESET_PASSWORD = 'reset_password',
  CONFIRM_PASSWORD = 'confirm_password',
  PASSWORD_CHANGED = 'password_changed',
}
